// extracted by mini-css-extract-plugin
module.exports = {"root":"AddEntityBtn_root__1gftE","icon":"AddEntityBtn_icon__2wmax"};